import  {  useState } from "react";
import { AppWrap, MotionWrap } from '../../wrapper'
import { client } from '../../client'
import { images } from '../../constants'

import './Footer.scss'


const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const { name, email, message } = formData

  const handleChangeInput = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }
  const handleSubmit = () => {
    setLoading(true)
    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message
    }
    client.create(contact).then(() => {
      setLoading(false)
      setIsFormSubmitted(true)
    })
  }
  return (
    <>
      <h2 className="head-text">Pegue seu café ☕ e bora trocar uma <span>&lt;ideia&gt;</span>.</h2>
      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="E-mail" />
          <a href="mailto:andrepc690@gmail.com" className="p-text">andrepc690@gmail.com</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="Mobile" />
          <a href="tel: +55 (16) 992162020" className="p-text">+55 (16) 992162020</a>
        </div>
      </div>
      {!isFormSubmitted ?
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input type="text" className="p-text" placeholder="seu nome" value={name} onChange={handleChangeInput} name="name" />
          </div>
          <div className="app__flex">
            <input type="email" className="p-text" placeholder="seu email" value={email} onChange={handleChangeInput} name="email" />
          </div>
          <div>
            <textarea name="message" className="p-text" placeholder="sua mensagem" value={message} onChange={handleChangeInput}></textarea>
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{loading ? 'Enviando...' : 'Enviar mensagem'}</button>
        </div>
        : <div>
          <h3 className="head-text">Thank you for getting in touch</h3>
        </div>
      }
    </>
  )
}

export default AppWrap(MotionWrap(Footer, 'app__footer'), 'contato', "app__whitebg")